import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getPortfolioGraphValue } from '../portfolioEndpoints'
import { portfolioKeys } from '../portfolioQueryKeys'

// `fiscalYear` ("2025-26"); undefined = the current fiscal year. The previous
// year's series stays on screen while a newly picked year loads.
export function usePortfolioGraphValueQuery(fiscalYear: MaybeRefOrGetter<string | undefined>) {
  return useQuery({
    queryKey: () => portfolioKeys.graph('value', toValue(fiscalYear)),
    queryFn: () => getPortfolioGraphValue(toValue(fiscalYear)),
    placeholderData: keepPreviousData,
  })
}
